module.exports = __webpack_public_path__ + "static/img/introduction-welcome-quote-2.70855af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-customers/introduction-welcome-quote-2.jpg
// module id = KQiL
// module chunks = 0